export const getExistUserType = (user, type) => {
    var _a;
    if (!((_a = user.values) === null || _a === void 0 ? void 0 : _a.length)) {
        return false;
    }
    return user.values.some(value => value.type === type);
};
